// extracted by mini-css-extract-plugin
var _1 = "Employee_defaultName__c0f09";
var _2 = "Employee_disabled__53594";
var _3 = "Employee_empty__9594e";
var _4 = "Employee_error__be379";
var _5 = "Employee_full__f1c0d";
var _6 = "Employee_fullName__a16d2";
var _7 = "Employee_fullRight__b7235";
var _8 = "Employee_fullRole__f7a2a";
var _9 = "Employee_info__df228";
var _a = "Employee_interactive__76358";
var _b = "Employee_large__28d1c";
var _c = "Employee_medium__6cafa";
var _d = "Employee_mention__7abc8";
var _e = "Employee_mini__7110c";
var _f = "Employee_name__c955e";
var _10 = "Employee_native__f461a";
var _11 = "Employee_removed__9fd54";
var _12 = "Employee_xmini__2568a";
export { _1 as "defaultName", _2 as "disabled", _3 as "empty", _4 as "error", _5 as "full", _6 as "fullName", _7 as "fullRight", _8 as "fullRole", _9 as "info", _a as "interactive", _b as "large", _c as "medium", _d as "mention", _e as "mini", _f as "name", _10 as "native", _11 as "removed", _12 as "xmini" }
